// extracted by mini-css-extract-plugin
export default {"sidebarmenu":"sidebar_sidebarmenu__LSPre","sidebarmenu_separator":"sidebar_sidebarmenu_separator__pI8uW","sidebar_list":"sidebar_sidebar_list__xBIbS"};